export default __webpack_public_path__ + "static/media/google-icon.437a0b2c.png";